import 'crypto-js/core';
import WordArray from 'crypto-js/lib-typedarrays';
import SHA256 from 'crypto-js/sha256';
import Base64Url from 'crypto-js/enc-base64url';
import Base64 from 'crypto-js/enc-base64';
import AES from 'crypto-js/aes';
import CFB from 'crypto-js/mode-cfb';
import NoPadding from 'crypto-js/pad-nopadding';
import Utf8 from 'crypto-js/enc-utf8';
import store from '@/store';
import { base64ToBase64Url, getFeature } from '@/common/js/utils';
import { GetUserDataError } from '@/utils/error';

class UidHandler {

    private readonly _enabled: boolean = false;

    public constructor() {

        this._enabled = getFeature( 'main.encryptUid', true );

    }

    public encrypt( plaintext: string ): string {

        if ( !plaintext ) {

            return '';

        }

        if ( !this._enabled ) {

            return plaintext;

        }

        if ( store.getters.userId ) {

            const { key, iv } = this._getKeyIv();

            return AES.encrypt( plaintext, WordArray.create( key ), {
                iv: WordArray.create( iv ),
                mode: CFB,
                padding: NoPadding,
            }).ciphertext.toString( Base64Url );

        } else {

            return base64ToBase64Url( btoa( plaintext ));

        }

    }

    public decrypt( ciphertext: string ): string {

        if ( !ciphertext ) {

            return '';

        }

        if ( !this._enabled ) {

            return ciphertext;

        }
        if ( store.getters.userId ) {

            try {

                const { key, iv } = this._getKeyIv();

                const base64Url = Base64Url.parse( ciphertext ).toString( Base64 );

                return AES.decrypt( base64Url, WordArray.create( key ), {
                    iv: WordArray.create( iv ),
                    mode: CFB,
                    padding: NoPadding
                }).toString( Utf8 );
            
            } catch ( e: unknown ) {

                console.error( 'decrypt error', e );
                throw new GetUserDataError( 'decrypt sim fail' );
            
            }

        } else {

            // atob(forgiving-base64 decode)
            return atob( ciphertext );

        }

    }

    private _getKeyIv(): { key: string; iv: string; } {

        const srcData = store.getters.userId;
        if ( !srcData ) {

            throw new TypeError( `Get empty encrypt key: ${srcData}` );

        }
        const keySrc = SHA256( `${store.getters.userId}` );
        // userId sha256获取 32位字符串，前16位做key，后16位为iv
        const aesKey = keySrc.words.slice( 0, 4 );
        const aesIv = keySrc.words.slice( 4, 8 );
        return {
            key: aesKey,
            iv: aesIv
        };

    }

}

export const uidHandler = new UidHandler();
